import React, {Component} from 'react';
import {Button, Form, Grid, Header, Icon, Input, Label, Message, Radio, Segment,Divider,List} from "semantic-ui-react";
import ListingContainer from "../../containers/listing_container";
import {COMPANY_API_URL, PROPERTY_API_URL} from '../../constants/api_routes';
import {getAddressesByPincode, getAgentsOfCompany, getListingData} from "../../data/user_api";
import PropertyAddressSearch from './property_address_select';
import CreateAgentUser from "../user/agent/create_user";

class CreateProperty extends Component {

    constructor(props) {
        super(props);
        this.state = {
            furnishingType: undefined,
            garage: "no",
            alarm: "no",
            success: false,
            numberOfBedroom: undefined,
            invalidRoomCount: false,
            furnishInvalid: false,
            agentListOptions: [],
            companyId: undefined,
            assignedAgent: undefined,
            companyListOptions: [],
            companyValid: true,
            agentValid: true,
            currentUser: undefined,
            addressId: undefined,
            fromExistingAddress: undefined,
            addressDetail:{},
            showAddCompany:false,
            showAddAgentWindow:false,
            addressOptions:[],
            submitting:false,
            isLoadingLookup:false
        }
    }

    componentWillMount() {
        this.getCompanyList().then(() => {
        });
        let currentUser = JSON.parse(localStorage.getItem('user'));
        if(currentUser.role === 'agent'){
            this.setState({fromExistingAddress:true});
        }
        this.setState({currentUser: currentUser});
    }

    handleSubmit = (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        if (this.state.numberOfBedroom === undefined) {
            this.setState({invalidRoomCount: true});
            return null;
        }
        if (this.state.currentUser.role !== 'agent' && this.state.assignedAgent === undefined) {
            this.setState({agentValid: false});
            return null;
        }
        if (this.state.furnishingType === undefined) {
            this.setState({furnishInvalid: true});
            return null;
        }
        this.setState({submitting:true});
        formData.append("no_of_bedrooms", this.state.numberOfBedroom);
        formData.append("furnishing_type", this.state.furnishingType);
        this.props.create(PROPERTY_API_URL, formData, this.handleCreateResponse, this.props.noLoad);
    };

    handleCreateResponse = (response) => {
        if (response.success) {
            this.setState({success: true});
            this.props.back();
        }
        else {
            this.setState({success: false});
        }
        this.setState({submitting:false});
    };

    getAgentList = async (companyId) => {
        const agentList = await getAgentsOfCompany(COMPANY_API_URL, companyId);
        let agentOptions = [];
        for (let i = 0; i < agentList.length; i++) {
            let obj = {
                key: agentList[i].id,
                text: agentList[i].name,
                value: agentList[i].id
            };
            agentOptions.push(obj);
        }
        this.setState({agentListOptions: agentOptions});
    };

    getCompanyList = async () => {
        const companyList = await getListingData(COMPANY_API_URL);
        let companyOptions = [];
        for (let i = 0; i < companyList.length; i++) {
            let obj = {
                key: companyList[i].id,
                text: companyList[i].name,
                value: companyList[i].id
            };
            companyOptions.push(obj);
        }
        this.setState({companyListOptions: companyOptions});
    };

    handleGetAddress = async () => {
        if(this.state.postcode){
            this.setState({isLoadingLookup:true})
            const addressList = await getAddressesByPincode(this.state.postcode.toString().replace(/ /g, ""));
            let data = addressList.data
            if(data.result){
                const addresses = data.result;
                console.log(addresses)
                let addressOptions = [];
                for (let i = 0; i < addresses.length; i++) {
                    let obj = {
                        key: i,
                    text: [ addresses[i]["line_1"], addresses[i]["line_2"], addresses[i]["line_3"], ] .filter(function (v) { return v && v.trim(); }) .map(function (v) { return v.trim(); }) .join(", "),
                        value: addresses[i]
                    };
                    addressOptions.push(obj);
                }
                this.setState({addressOptions: addressOptions,isLoadingLookup:false});
            }
            else {
                let errormsg =data.message || "Postcode does not exist, or daily limit has been reached";
                this.setState({isLoadingLookup:false, addressOptions: [{ key: "1", text: errormsg, value: errormsg }] })
            }
        }
    };

    onNewAgentAdded = () => {
        this.setState({companyLoading:true});
        this.getCompanyList().then(()=>{this.setState({companyLoading:false,showAddAgentWindow:false,companyId:undefined,assignedAgent:undefined})});
    };

    handleAddressSelectFromExisting = (isTrue, addressId,addressDetail) => {
        this.setState({fromExistingAddress: isTrue, addressId: addressId,addressDetail:addressDetail});
    };

    handleAddressSelect = (address) => {
  
      this.setState({addrLine1: [address["line_1"], address["line_2"]].filter(Boolean).join(", "),
      addrLine2:`${address["line_3"]||""}`,locality:address["county"],city:address["post_town"],country:address["country"]})
    };

    render() {
        const addressOptions = this.state.addressOptions;
        const readOnlyAddress = this.state.fromExistingAddress && this.state.currentUser.role !== 'agent';
        const addressDetail = this.state.addressDetail;
        const furnishOptions = [
            {key: '1', text: 'Furnished', value: '0'},
            {key: '2', text: 'Part-Furnished', value: '2'},
            {key: '3', text: 'Un-Furnished', value: '1'},
        ];

        const bedRoomOptions = [
            {key: '1', text: 'Studio', value: '0'},
            {key: '2', text: '1 Bedroom', value: '1'},
            {key: '3', text: '2 Bedroom', value: '2'},
            {key: '4', text: '3 Bedroom', value: '3'},
            {key: '5', text: '4 Bedroom', value: '4'},
            {key: '6', text: '5 Bedroom', value: '5'},
            {key: '7', text: '6 Bedroom', value: '6'},
            {key: '8', text: '7 Bedroom', value: '7'},
            {key: '9', text: '8 or Above Bedroom', value: '8'},
        ];

        const {garage, alarm} = this.state;
        const currentUserDetails = this.state.currentUser;
        return (
            <div>
                {!this.state.showAddAgentWindow && <Header size='large' textAlign='center'>
                         Create New Property
                </Header>}
                {this.state.addressId && !this.state.showAddAgentWindow && <div className="modal-back-button">
                    <Button basic icon onClick={() => this.setState({fromExistingAddress: undefined, addressId: undefined})}>
                        <Icon name='arrow left'/>
                    </Button>
                </div>}
                {this.state.success && <Message
                    onDismiss={() => this.setState({success: false})}
                    header='Success!'
                    content='Property Created Successfully!!'
                    color='green'
                    fluid
                />}

                {(this.state.fromExistingAddress === undefined && !this.state.showAddAgentWindow) &&
                <PropertyAddressSearch addressSelected={this.handleAddressSelectFromExisting}/>}
                {(this.state.fromExistingAddress !== undefined && !this.state.showAddAgentWindow) && <div><Form onSubmit={this.handleSubmit}>
                    <Grid stackable>
                        <Grid.Row>
                            <Grid.Column width={8}>
                                <Segment style={{height: '100%'}}>
                                    <Label color='blue' ribbon>
                                        Property Address Details
                                    </Label>
                                    <p></p>
                                    <Form.Input label='Address Line 1' fluid placeholder='Street' value={this.state.addrLine1} onChange={(e)=>{this.setState({addrLine1:e.target.value})}} defaultValue={addressDetail['line1']}
                                                type='text' name="line1" readOnly={readOnlyAddress}
                                                required/>
                                    <Form.Input label='Address Line 2' fluid placeholder='Landmark' value={this.state.addrLine2} onChange={(e)=>{this.setState({addrLine2:e.target.value})}} defaultValue={addressDetail['line2']}
                                                type='text' name="line2" readOnly={readOnlyAddress}
                                    />
                                    <Form.Group widths={2}>
                                        <Form.Input label='Locality' fluid placeholder='Region' value={this.state.locality} onChange={(e)=>{this.setState({locality:e.target.value})}} defaultValue={addressDetail['locality']}
                                                    type='text' name="locality" readOnly={readOnlyAddress}
                                        />
                                        <Form.Input label='City' fluid placeholder='City' value={this.state.city} onChange={(e)=>{this.setState({city:e.target.value})}} defaultValue={addressDetail['city']}
                                                    type='text' name="city" readOnly={readOnlyAddress}
                                        />
                                    </Form.Group>

                                    <Form.Group widths="equal">
                                    <Form.Field>
                                        <label>Postcode</label>
                                     <Input fluid placeholder="C2PN57" defaultValue={addressDetail['postcode']} type="text" name="postcode" onChange={(e) => this.setState({ postcode: e.target.value })} required readOnly={readOnlyAddress} action={ <Button type="button" onClick={this.handleGetAddress} loading={this.state.isLoadingLookup} disabled={!this.state.postcode || this.state.postcode.length < 4} icon labelPosition="left" > <Icon name="search" /> Postcode Lookup </Button> } />
                                    </Form.Field>
                                    </Form.Group>

                                    {this.state.addressOptions && this.state.addressOptions.length > 0 && (
                                        <Segment
                                        style={{  marginTop: "1rem", maxHeight: "100px",   overflowY: "auto", padding: 0 }} >
                                        <List animated className="lookupList"selection size="small" divided >
                                            {this.state.addressOptions.map((option, index) => (
                                            <List.Item  key={index} onClick={() => this.handleAddressSelect(option.value)} style={{  wordBreak: "break-word" }}>{option.text} </List.Item> ))} </List>
                                        </Segment>
                                    )}
                                </Segment>
                            </Grid.Column>
                            <Grid.Column width={8}>
                                <Segment style={{height: '100%'}}>
                                    <Label color='blue' ribbon>
                                        Property Specifications
                                    </Label>
                                    <p></p>
                                    <input type='hidden' name='agent_profile_id'
                                           defaultValue={currentUserDetails['role'] === 'agent' ? currentUserDetails['profile_id'] : this.state.assignedAgent}/>
                                    <input type='hidden' name='property_address_id' value={this.state.fromExistingAddress ?this.state.addressId:undefined}/>
                                    
                                    {currentUserDetails['role'] === 'admin' &&
                                            <Form.Dropdown
                                                label='Company Name'
                                                required
                                                search
                                                error={!this.state.companyValid}
                                                selection
                                                noResultsMessage="Company not found"
                                                wrapSelection={false}
                                                options={this.state.companyListOptions}
                                                placeholder='Company Name'
                                                value={this.state.companyId}
                                                onFocus={()=>this.setState({companyValid:true})}
                                                onChange={(e, option) => {
                                                    this.setState({companyId: option.value});
                                                    this.getAgentList(option.value).then();
                                                }}
                                            />
                                    }
                                    {currentUserDetails['role'] === 'admin' &&
                                    <div className='clearfix'>
                                        <div className="pull-left" style={{width:'85%'}}>
                                            <Form.Dropdown 
                                                label='Agent Name'
                                                required
                                                search
                                                error={!this.state.agentValid}
                                                selection
                                                noResultsMessage="Agent not found"
                                                wrapSelection={false}
                                                options={this.state.agentListOptions}
                                                placeholder='Agent Name'
                                                value={this.state.assignedAgent}
                                                onFocus={()=>this.setState({agentValid:true})}
                                                onChange={(e, option) => {
                                                    this.setState({assignedAgent: option.value})
                                                }}
                                            />
                                        </div>
                                        <div style={{marginTop:'7%',paddingBottom:'6%'}} className="pad-left pull-left icon-button" onClick={()=>{this.setState({showAddAgentWindow:true})}}>
                                            <Icon name='user plus' size="large" />
                                        </div>
                                    </div>
                                    }
                                    <Form.Group widths={2}>
                                        <Form.Field required>
                                            <label className="required">No. of Bedrooms</label>
                                        </Form.Field>
                                        <Form.Dropdown
                                            required
                                            selection
                                            error={this.state.invalidRoomCount}
                                            wrapSelection={false}
                                            options={bedRoomOptions}
                                            placeholder='No. of bedrooms'
                                            onFocus={()=>this.setState({invalidRoomCount:false})}
                                            onChange={(e, option) => {
                                                this.setState({numberOfBedroom: option.value})
                                            }}
                                        />
                                    </Form.Group>
                                    <Form.Group widths={2}>
                                        <Form.Field required>
                                            <label>Furnishing Type </label>
                                        </Form.Field>
                                        <Form.Dropdown
                                            required
                                            selection
                                            error={this.state.furnishInvalid}
                                            wrapSelection={false}
                                            options={furnishOptions}
                                            placeholder='Furnishing Type'
                                            onFocus= {()=>this.setState({furnishInvalid:false})}
                                            onChange={(e, option) => {
                                                this.setState({furnishingType: option.value})
                                            }}
                                        />
                                    </Form.Group>
                                    {/* <Form.Group widths={2}>
                                        <Form.Field>
                                            <label>No. of Bathrooms </label>
                                        </Form.Field>
                                        <Form.Field>
                                            <Input placeholder='1 0r 2' name="no_of_bathrooms"/>
                                        </Form.Field>
                                    </Form.Group>
                                   
                                    <Form.Group widths={2}>
                                        <Form.Field>
                                        <label>Property contains garage?</label>
                                        </Form.Field>
                                        <div>
                                            <Form.Group widths={2}>
                                                <Form.Field
                                                    control={Radio}
                                                    label='Yes'
                                                    value='yes'
                                                    name="garage"
                                                    checked={garage === 'yes'}
                                                    onChange={(e, {value}) => {
                                                        this.setState({garage: value})
                                                    }}
                                                />
                                                <Form.Field
                                                    control={Radio}
                                                    label='No'
                                                    value='no'
                                                    name="garage"
                                                    checked={garage === 'no'}
                                                    onChange={(e, {value}) => {
                                                        this.setState({garage: value})
                                                    }}
                                                />
                                            </Form.Group>
                                        </div>
                                    </Form.Group> */}
                                    <Form.Group widths={2}>
                                        <Form.Field>
                                            <label>Property Notes</label>
                                    </Form.Field>
                                            <Form.TextArea placeholder="Meter Location/Serials and other information here" type="text"
                                            name="property_notes" />
                                    </Form.Group>

                                    {/* <Form.Group widths={2}>
                                        <Form.Field>
                                        <label> Is Alarm Available? </label>
                                        </Form.Field>
                                        <div>
                                            <Form.Group widths={2}>
                                                <Form.Field
                                                    control={Radio}
                                                    label='Yes'
                                                    value='yes'
                                                    name="alarm"
                                                    checked={alarm === 'yes'}
                                                    onChange={(e, {value}) => {
                                                        this.setState({alarm: value})
                                                    }}
                                                />
                                                <Form.Field
                                                    control={Radio}
                                                    label='No'
                                                    value='no'
                                                    name="alarm"
                                                    checked={alarm === 'no'}
                                                    onChange={(e, {value}) => {
                                                        this.setState({alarm: value})
                                                    }}
                                                />
                                            </Form.Group>
                                        </div>
                                    </Form.Group> */}

                                </Segment>
                            </Grid.Column>
                            </Grid.Row>
                    </Grid>
                    <div className="submit-buttons" style={{padding: '1%'}}>
                        <Button type='submit' primary disabled={this.state.submitting}>Create Property</Button>
                    </div>
                </Form></div>}
                {this.state.showAddAgentWindow && <CreateAgentUser onSuccess={this.onNewAgentAdded} companyId={this.state.companyId} cancel={true} close={()=>{this.setState({showAddAgentWindow:false})}}/>}
            </div>);
    }
}

export default ListingContainer(CreateProperty);


// WEBPACK FOOTER //
// ./src/views/properties/create_property.js